import { Component, Input } from '@angular/core';
import { from, Observable } from 'rxjs';
import { NgFor, AsyncPipe } from '@angular/common';
import { TileComponent } from '../tile/tile.component';

@Component({
  selector: 'app-tile-container',
  templateUrl: 'tile.container.component.html',
  imports: [NgFor, TileComponent, AsyncPipe],
})
export class TileContainerComponent {
  @Input() items: Observable<object[]> = from([]);

  /**
   * Get the data for the tile items
   * @returns {Record<string, unknown>[]}
   */
  get items$(): Observable<object[]> {
    return this.items;
  }
}
